import { mergeQueryKeys } from '@lukemorales/query-key-factory';
import { accountsQueryKeys } from 'domains/accounts/query-keys/accounts.query-keys';
import { assetsQueryKeys } from 'domains/assets/query-keys/assets.query-key';
import { auditQueryKeys } from 'domains/audit/query-keys/audit.query-keys';
import { branchQueryKeys } from 'domains/branches/query-keys/branch.query-key';
import { counterpartiesQueryKeys } from 'domains/counterparties/query-keys/counterparty.query-key';
import { customersQueryKeys } from 'domains/customers/query-keys/customers.query-key';
import { emissionQueryKeys } from 'domains/emission/query-keys/emission.query-key';
import { employeesQueryKeys } from 'domains/employees/query-keys/employees.query-keys';
import { limitsQueryKeys } from 'domains/limits/query-keys/limits.query-key';
import { merchantQueryKeys } from 'domains/merchant/query-keys/merchant.query-keys';
import { permissionsQueryKeys } from 'domains/permissions/query-keys/permissions.query-keys';
import { reconciliationQueryKeys } from 'domains/reconciliation/query-keys/reconciliation.query-key';
import { reportingQueryKeys } from 'domains/reporting/query-keys/reporting.query-key';
import { rbacQueryKeys } from 'domains/roles/query-keys/roles.query-keys';
import { segmentsQueryKeys } from 'domains/segments/query-keys/segments.query-key';

export const queryKeysClient = mergeQueryKeys(
  accountsQueryKeys,
  assetsQueryKeys,
  branchQueryKeys,
  counterpartiesQueryKeys,
  customersQueryKeys,
  emissionQueryKeys,
  employeesQueryKeys,
  limitsQueryKeys,
  merchantQueryKeys,
  permissionsQueryKeys,
  rbacQueryKeys,
  reconciliationQueryKeys,
  reportingQueryKeys,
  segmentsQueryKeys,
  permissionsQueryKeys,
  auditQueryKeys,
);
